import WorksheetQuestions from './WorksheetQuestions';
import { WORKSHEET_CLASSES } from '../../constants/classNames';
import { getSiteEngine } from '../../data/sitePages';
import { sortIntoMaterialGroups } from '../../utils/worksheetUtils';

/**
 * A word bank of elements to sort into metals, non-metals and metalloids.
 */
export default function MetalsSortSheet({ worksheet, showAnswers }) {
  const engine = getSiteEngine();
  const elements = worksheet.symbols.map((id) => engine.getSubstance(id));
  const groups = sortIntoMaterialGroups(elements);

  return (
    <>
      {!showAnswers && (
        <section className={WORKSHEET_CLASSES.part}>
          <h2 className={WORKSHEET_CLASSES.partTitle}>Word bank</h2>
          <p className={WORKSHEET_CLASSES.wordBank}>
            {elements.map((element) => `${element.name} (${element.symbol})`).join(' · ')}
          </p>
        </section>
      )}
      <section className={WORKSHEET_CLASSES.part}>
        <h2 className={WORKSHEET_CLASSES.partTitle}>Sort them</h2>
        <div className={WORKSHEET_CLASSES.columns}>
          {Object.entries(groups).map(([group, members]) => (
            <div key={group} className={WORKSHEET_CLASSES.column}>
              <h3 className={WORKSHEET_CLASSES.columnTitle}>{group}</h3>
              {showAnswers ? (
                <ul className={WORKSHEET_CLASSES.answerList}>
                  {members.map((element) => (
                    <li key={element.id} className={WORKSHEET_CLASSES.answer}>
                      {element.name} ({element.symbol})
                    </li>
                  ))}
                </ul>
              ) : (
                <div className={WORKSHEET_CLASSES.writeArea} />
              )}
            </div>
          ))}
        </div>
      </section>
      <WorksheetQuestions questions={worksheet.questions} showAnswers={showAnswers} />
    </>
  );
}
